// cat. into common modules
import {
    hexToRgba
} from "@into/into-common-utils";

export default class Enum {
    // FRONTEND ENUMS
    // ================================



    static get FE_TAG_DOMAIN() {
        return {
            DOCUMENT_STATUS: "DOCUMENT_STATUS",
            DOCUMENT_TYPE: "DOCUMENT_TYPE",
            TIMESTAMP_STATUS: "TIMESTAMP_STATUS",
            TIMESTAMP_TYPE: "TIMESTAMP_TYPE",
            TIMESTAMP_MODULE: "TIMESTAMP_MODULE",
            WATERMARK_TYPE: "WATERMARK_TYPE",
            VIEWER_ACTION: "VIEWER_ACTION",
            VIEWER_STATUS: "VIEWER_STATUS",
            VIEWER_TYPE: "VIEWER_TYPE",
        }
    }

    static get FE_SORT_KEY() {
        return {
            NAME: "name",
            CREATED_DATE: "createdDate",
            UPDATED_DATE: "updatedDate"
        }
    }

    static get FE_CONDITION_KEY() {
        return {
            ID: "id",
            AUTH_ID: "authId",
            NAME: "name",
            STATUS: "status",
        }
    }

    static get FE_DEVICE_MODE() {
        return {
            DEFAULT: "DEFAULT",
            DESKTOP: "DESKTOP",
            LAPTOP: "LAPTOP",
            TABLET: "TABLET",
        }
    }

    static get FE_DEVICE_CONTAINER_STYLE() {
        return {
            DEFAULT: {
                width: 1637,
                paddingLeft: 50,
                paddingRight: 50,
            },
            DESKTOP: {
                width: 1229,
                paddingLeft: 45,
                paddingRight: 45,
            },
            LAPTOP: {
                width: 930,
                paddingLeft: 45,
                paddingRight: 45,
            },
            TABLET: {
                width: 674,
                paddingLeft: 40,
                paddingRight: 40,
            },
        }
    }

    static get FE_HTTP_METHOD() {
        return {
            GET: "GET",
            POST: "POST",
        }
    }

    static get FE_HTTP_CONTENT_TYPE() {
        return {
            BLOB: "blob",
            JSON: "application/json",
            MULTIPART: "multipart/form-data",
        }
    }

    static get FE_TOKEN_TYPE() {
        return {
            MEMBER: "MEMBER",
            VIEW: "VIEW",
        }
    }

    static get FE_DOMAIN_DATA_TYPE() {
        return {
            NUMBER: "NUMBER",       // NUMBER
            TEXT: "TEXT",           // STRING
            DATA: "DATA",           // LARGE OBJECT
            DATE: "DATE",           // DATE
            BOOLEAN: "BOOLEAN",     // BOOLEAN
            ENUM: "ENUM",           // ENUM
            ARRAY: "ARRAY"          // ARRAY
        }
    }

    static get FE_COMMUNICATION_FORMAT() {
        return {
            COMMUNICATION_DATE_FORMAT: "YYYYMMDD",
            COMMUNICATION_TIME_FORMAT: null,    // null is "millisecond" or "unix"
        }
    }

    static get FE_DATA_FORMAT() {
        return {
            YYYYMMDD: "YYYY. MM. DD",
            YYYYMMDD_HHmm: "YYYY. MM. DD <i>| HH:mm</i>",
        }
    }

    static get FE_WATERMARK_PAGE() {
        return {
            ALL: "-1",
            FIRST: "0",
            SELECT: "1"
        }
    }

    static get FE_WATERMARK_POSITION() {
        return {
            ALL: "-1",
            SELECT: "5"
        }
    }

    /**
     * Watermark Resource Align (Horizontal)
     * 워터마크 리소스 가로 정렬
     */
    static get FE_WATERMARK_RESOURCE_ALIGN_HOR() {
        return {
            LEFT: "left",
            CENTER: "center",
            RIGHT: "right"
        }
    }

    /**
     * Watermark Resource Align (Vertical)
     * 워터마크 리소스 세로 정렬
     */
    static get FE_WATERMARK_RESOURCE_ALIGN_VER() {
        return {
            TOP: "top",
            MIDDLE: "middle",
            BOTTOM: "bottom"
        }
    }

    /**
     * Short Cut Function
     * 단축키 기능
     */
    static get FE_SHORT_CUT_FUNC() {
        return {
            EMPTY: "",
            PRINT: "PRINT",
            DOWNLOAD: "DOWNLOAD",
            FULLSCREEN: "FULLSCREEN",
        }
    }

    /**
     * Short Cut Command
     * 단축키 커맨드
     */
    static get FE_SHORT_CUT_CMD() {
        return {
            EMPTY: "",
            NONE: "NONE",
            CTRL: "CTRL",
            ALT: "ALT",
            SHIFT: "SHIFT",
            META: "META",
        }
    }

    /**
     * Short Cut Key Code
     * 단축키 키코드
     */
    static get FE_SHORT_CUT_KEYCODE() {
        return {
            EMPTY: "",
            A: "65",
            B: "66",
            C: "67",
            D: "68",
            E: "69",
            F: "70",
            G: "71",
            H: "72",
            I: "73",
            J: "74",
            K: "75",
            L: "76",
            M: "77",
            N: "78",
            O: "79",
            P: "80",
            Q: "81",
            R: "82",
            S: "83",
            T: "84",
            U: "85",
            V: "86",
            W: "87",
            X: "88",
            Y: "89",
            Z: "90",
        }
    }






    static get FE_SYSTEM_PAGE_TABS() {
        return {
            BASE: "BASE",
            PRODUCT: "PRODUCT",
            VIEWER: "VIEWER"
        }
    }



    // BACKEND ENUMS (from Server)
    // ================================

    /**
     * Member Role
     * 멤버 권한
     */
    static get BE_MEMBER_ROLE() {
        return {
            UNLIMIT: "UNLIMIT",                     // 제한 없는 권한
            SYSTEM_CONTROL: "SYSTEM_CONTROL",       // 시스템 제어
            SYSTEM_MANAGE: "SYSTEM_MANAGE",         // 시스템 관리
        }
    }

    /**
     * Member Role Style
     * 멤버 권한 별 스타일
     */
    static get BE_MEMBER_ROLE_STYLE() {
        return {
            "UNLIMIT": {
                color: "#177BF5",
                background: hexToRgba("#177BF5", 0.1)
            },
            "SYSTEM_CONTROL": {
                color: "#177BF5",
                background: hexToRgba("#177BF5", 0.1)
            },
            "SYSTEM_MANAGE": {
                color: "#177BF5",
                background: "#F9FAFA"
            },
        }
    }

    /**
     * Document Status
     * 문서 상태
     */
    static get BE_DOCUMENT_STATUS() {
        return {
            CONVERT_WAIT: "CONVERT_WAIT",           // 변환 대기
            CONVERT_READY: "CONVERT_READY",         // 변환 준비
            CONVERT_PROGRESS: "CONVERT_PROGRESS",   // 변환 진행중
            CONVERT_FAILURE: "CONVERT_FAILURE",     // 변환 실패
            COMPLETE: "COMPLETE",                   // 완료
            DELETED: "DELETED"                      // 삭제
        }
    }

    /**
     * Document Type
     * 문서 타입
     */
    static get BE_DOCUMENT_TYPE() {
        return {
            PDF: "PDF",         // PDF 문서
            IMAGE: "IMAGE",     // 이미지 문서
        }
    }

    /**
     * Timestamp Status
     * 타임스탬프 상태
     */
    static get BE_TIMESTAMP_STATUS() {
        return {
            VERIFIED: "VERIFIED",       // 검증 (code: 1)
            MODIFIED: "MODIFIED",       // 수정됨 (code: 2)
            FAILED: "FAILED",         // 실패 (code: 3)
        }
    }

    /**
     * Timestamp Type
     * 타임스탬프 타입
     */
    static get BE_TIMESTAMP_TYPE() {
        return {
            CROSSERT: "CROSSERT",       // 크로서트
            GTSA: "GTSA",               // GTSA
            KFTC: "KFTC",               // 금융결제원
            KICA: "KICA",               // 한국정보인증
            KOSCOM: "KOSCOM",           // 코스콤
            KTNET: "KTNET",             // KTNET
        }
    }

    /**
     * Timestamp Module
     * 타임스탬프 모듈
     */
    static get BE_TIMESTAMP_MODULE() {
        return {
            AMANO: "AMANO",     // 아마노
            DREAM: "DREAM",     // 드림시큐
        }
    }

    /**
     * Watermark Type
     * 워터마크 타입
     */
    static get BE_WATERMARK_TYPE() {
        return {
            TEXT: "TEXT",       // 텍스트
            IMAGE: "IMAGE",     // 이미지
        }
    }

    /**
     * Viewer Action
     * 뷰어 액션
     */
    static get BE_VIEWER_ACTION() {
        return {
            ALL: "ALL",             // 전체
            HIT: "HIT",             // 조회
            PRINT: "PRINT",         // 출력
            DOWNLOAD: "DOWNLOAD",   // 다운로드
        }
    }

    /**
     * Viewer Status
     * 뷰어 상태
     */
    static get BE_VIEWER_STATUS() {
        return {
            ACTIVE: "ACTIVE",                       // 활성
            DELETED: "DELETED",                     // 삭제
            EXPIRED: "EXPIRED",                     // 만료
        }
    }

    /**
     * Timestamp Status Style
     * 타임스탬프 상태별 스타일
     */
    static get BE_TIMESTAMP_STATUS_STYLE() {
        return {
            VERIFIED: {
                color: "#32CD32",           // 검증: 라임색
                background: hexToRgba("#32CD32", 0.1)
            },
            MODIFIED: {
                color: "#FF6347",           // 수정됨: 토마토색
                background: hexToRgba("#FF6347", 0.1)
            },
            FAILURE: {
                color: "#FF0000",           // 실패: 빨간색
                background: hexToRgba("#FF0000", 0.1)
            },
        }
    }

    /**
     * Watermark Type Style
     * 워터마크 타입별 스타일
     */
    static get BE_WATERMARK_TYPE_STYLE() {
        return {
            TEXT: {
                color: "#0000FF",           // 텍스트: 파란색
                background: hexToRgba("#0000FF", 0.1)
            },
            IMAGE: {
                color: "#A52A2A",           // 이미지: 갈색
                background: hexToRgba("#A52A2A", 0.1)
            },
        }
    }

    /**
     * Viewer Action Style
     * 뷰어 액션별 스타일
     */
    static get BE_VIEWER_ACTION_STYLE() {
        return {
            ALL: {
                color: "#000000",               // 전체: 검정색
                background: hexToRgba("#000000", 0.1)
            },
            HIT: {
                color: "#FFD700",               // 히트: 금색
                background: hexToRgba("#FFD700", 0.1)
            },
            PRINT: {
                color: "#008000",               // 인쇄: 초록색
                background: hexToRgba("#008000", 0.1)
            },
            DOWNLOAD: {
                color: "#1E90FF",               // 다운로드: 도전자파란색
                background: hexToRgba("#1E90FF", 0.1)
            },
        }
    }

    /**
     * Document Status Style
     * 문서 상태별 스타일
     */
    static get BE_DOCUMENT_STATUS_STYLE() {
        return {
            CONVERT_NONE: {                                     // 변환이 돌지 않음.
                color: "#fcc419",
                background: hexToRgba("#fcc419", 0.1),
            },
            CONVERT_WAIT: {                                     // 변환 대기
                color: "#fcc419",
                background: hexToRgba("#fcc419", 0.1),
            },
            CONVERT_READY: {                                    // 변환
                color: "#fcc419",
                background: hexToRgba("#fcc419", 0.1),
            },
            CONVERT_PROGRESS: {                                 // 변환 진행중
                color: "#fcc419",
                background: hexToRgba("#fcc419", 0.1),
            },
            CONVERT_FAILURE: {                                  // 변환 실패
                color: "#ff6b6b",
                background: hexToRgba("#ff6b6b", 0.1)
            },
            COMPLETE: {                                         // 완료
                color: "#00B4B4",
                background: hexToRgba("#00B4B4", 0.1),
            },
            DELETED: {                                          // 삭제
                color: "#ff6b6b",
                background: hexToRgba("#ff6b6b", 0.1)
            }
        }
    }

    /**
     * Viewer Status Style
     * 뷰어 상태별 스타일
     */
    static get BE_VIEWER_STATUS_STYLE() {
        return {
            "ACTIVE": {
                color: "#177BF5",
                background: hexToRgba("#177BF5", 0.1)
            },
            "DELETED": {
                color: "#34B977",
                background: hexToRgba("#34B977", 0.1)
            },
            "EXPIRED": {
                color: "#8B95A1",
                background: hexToRgba("#8B95A1", 0.1)
            },
        }
    }

    /**
     * Viewer Type
     * 뷰어 타입
     */
    static get BE_VIEWER_TYPE() {
        return {
            DEFAULT: "DEFAULT",     // 기본
            LIST: "LIST",           // 리스트
            ZIP: "ZIP",             // ZIP
        }
    }

    /**
     * Viewer Type Style
     * 뷰어 타입별 스타일
     */
    static get BE_VIEWER_TYPE_STYLE() {
        return {
            "DEFAULT": null,
            "LIST": null,
            "ZIP": null,
        }
    }

    /**
     * System Config Type
     * 시스템 설정 타입
     */
    static get BE_SYSTEM_CONFIG_TYPE() {
        return {
            SYSTEM: "SYSTEM",               // 시스템
            VIEW_CONFIG: "VIEW_CONFIG",     // 뷰 설정
        }
    }

    /**
     * View Config Screen Mode
     * 뷰 설정 화면 모드
     */
    static get BE_VIEW_CONFIG_SCREEN_MODE() {
        return {
            BASIC: "BASIC",         // 기본
            E_BOOK: "E_BOOK",       // E-Book
            DMV: "DMV"              // 통합보기
        }
    }

    /**
     * View Config Scale Mode
     * 뷰 설정 열람 배율 모드
     */
    static get BE_VIEW_CONFIG_SCALE_MODE() {
        return {
            AUTO: "AUTO",                   // 자동
            WIDTH: "WIDTH",       // 페이지 너비 맞추기
            HEIGHT: "HEIGHT"            // 페이지 높이 맞추기
        }
    }

    /**
     * Hook Event Type
     * 훅 이벤트 타입
     */
    static get BE_HOOK_EVENT_TYPE() {
        return {
            DOCUMENT_CONVERSION: "DOCUMENT_CONVERSION",     // 문서 변환
        }
    }

    /**
     * Hook Status
     * 훅 상태
     */
    static get BE_HOOK_STATUS() {
        return {
            WAIT: "WAIT",           // 대기
            READY: "READY",         // 준비
            PROGRESS: "PROGRESS",   // 진행
            FAILURE: "FAILURE",     // 실패
            COMPLETE: "COMPLETE"    // 완료
        }
    }

    /**
     * Hook Type
     * 훅 타입
     */
    static get BE_HOOK_TYPE() {
        return {
            CALLBACK: "CALLBACK",   // 콜백
        }
    }

    /**
     * Event Domain
     * 이벤트 도메인
     */
    static get BE_EVENT_DOMAIN() {
        return {
            DOCUMENT: "DOCUMENT",   // 문서
        }
    }

    /**
     * Event Type
     * 이벤트 타입
     */
    static get BE_EVENT_TYPE() {
        return {
            CONVERTED: "CONVERTED",             // 변환 완료
            CONVERT_FAILED: "CONVERT_FAILED",   // 변환 실패
        }
    }
}